import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useCart} from "../contexts/CartContext";
import axios from "axios";

const CheckoutSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {dispatch} = useCart();
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    // Clear the cart on successful checkout
    dispatch({type: "CLEAR_CART"});
  }, [dispatch]);

  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    const sync = async () => {
      if (!sessionId) return;
      try {
        setSyncing(true);
        await axios.post("/api/orders/sync-shipping", {session_id: sessionId});
      } catch (_e) {
        // non-blocking
      } finally {
        setSyncing(false);
      }
    };
    sync();
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto my-[20%] py-12 px-4">
      <div className="text-center">
        <div className="text-green-600 text-6xl mb-4">✓</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Payment Successful!
        </h1>
        <p className="text-gray-600 mb-6">
          Thank you for your purchase. Your order has been confirmed and you'll
          receive a confirmation email shortly.
        </p>
        {syncing && (
          <p className="text-xs text-gray-500 mb-4">
            Finalizing shipping details…
          </p>
        )}

        {/* {sessionId && (
          <p className="text-sm text-gray-500 break-all mb-8">
            Session ID: {sessionId}
          </p>
        )} */}

        <div className="space-y-4">
          <button onClick={() => navigate("/shop")} className="btn btn-primary">
            Continue Shopping
          </button>

          <button
            onClick={() => navigate("/")}
            className="btn btn-secondary block mx-auto"
          >
            Return Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
